import React from 'react';

const PanelContent = (props) => (
  <div className="panel-content">
    {props.children}
  </div>
);

export default PanelContent;